import React from "react";
import ListTable from "../../../Components/Table/ListTable";
import TeamsTableRow from "./TeamsTableRow";
import { useTranslation } from "../../../context/Internationalization";

const schema = (t) => [
  {
    id: 'name',
    label: t('team_name'),
    sortable: false,
    minWidth: 200,
  },
  {
    id: 'club',
    label: t('club_page_title'),
    sortable: false,
    minWidth: 200,
  },
  {
    id: 'teamCode',
    label: t('team_code'),
    sortable: false,
    minWidth: 160,
  },
  {
    id: 'role',
    label: t('role'),
    sortable: false,
    minWidth: 160,
  },
]

const TeamsTable = ({ data = [], menuActions = [], lastElementRef, emptyMessage }) => {
  const { t } = useTranslation();
  const rowElement = (dato, index) => <TeamsTableRow
      key={dato._id}
      lastElementRef={lastElementRef}
      data={dato}
      index={index}
      menuActions={menuActions}
  />

  return (
    <ListTable
      rows={data}
      columns={schema(t)}
      rowElement={rowElement}
      tableAriaLabel={t('teams')}
      minWidth={720}
      emptyMessage={emptyMessage}
    />
  );
};

export default TeamsTable;
